class ZeroFilterResultsComponentController {
}

const zeroFilterResultsComponentDefinition = {
    bindings: {
        term: '<?',
    },
    controller: ZeroFilterResultsComponentController,
    template: require('./zero-filter-results.component.html').trim(),
};

module.exports = {
    ZeroFilterResultsComponentController,
    zeroFilterResultsComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/zero-filter-results.component.js